export default {
  tagline: "El popular juego de palabras, en línea. 🕵️‍♂️",
  "create-game": "Crear un juego",
  "new-game": "Nuevo juego",
  "back-to-lobby": "Volver al lobby",
  "join-room": "Unirse a un juego",
  "no-public-room":
    "Actualmente no hay juegos públicos. ¡Crea uno e invita a tus amigos!",
  "how-to-play": "Cómo jugar",
  "game-tagline":
    "Codegame es un juego de adivinanzas en el que los equipos compiten para encontrar palabras relacionadas con una palabra clave dada por otro jugador.",
  "see-more": "Ver más...",
  "classic-rules": "Reglas clásicas",
  "duet-rules": "Reglas duet",
  "support-authors":
    "Si te gusta este juego, por favor apoya a los autores y compra una versión física!",
  "made-with-love": "Hecho con ♥ durante el encierro",
  "its-open-source": "Es <1>open-source</1>.",
  "check-our-privacy-policy": "Revisa nuestra <2>política de privacidad</2>.",
  "choose-options": "Elija sus opciones",
  "custom-words-placeholder": "harder, better, faster, stronger",
  "custom-words-warning":
    "Necesitas al menos 25 palabras para jugar solo con palabras personalizadas.",
  "custom-words-checkbox": "Fusionarse con el diccionario.",
  "custom-words-notice":
    "Ingrese una lista separada por comas de palabras personalizadas. Desmarque la casilla de abajo para usar esas palabras exclusivamente.",
  advanced: "avanzado...",
  "custom-words": "Palabras personalizadas",
  mode: "Modo",
  duet: "Duet",
  classic: "Clásico",
  dictionary: "Diccionario",
  "public-game": "Juego público",
  private: "Privado",
  public: "Público",
  "join-game": "Únete al juego",
  "placeholder-join": "únete al juego para empezar a chatear",
  "give-hint": "Dar pista",
  "clicked-on": "hizo clic en",
  "become-spymaster": "Conviértete en jefe de espías",
  "switch-teams": "Cambiar de equipo",
  "red-adj": "rojo",
  "blue-adj": "azul",
  "start-game-classic":
    "El jefe del equipo <1>{{team}}</1> da una pista para empezar el juego!!",
  "see-rules": "Ver reglas",
  "start-game-duet":
    "¡Haz clic en una tarjeta o da una pista para empezar el juego!",
  "copied-to-clipboard": "Copiado al portapapeles",
  "turns-left": "Queda {{ count }} turno",
  "turns-left_plural": "Quedan {{ count }} turnos",
  "game-over": "El juego se ha terminado.",
  "winner-team": "El equipo <1>{{team}}</1> gana.",
  "black-card-loss": "Perdiste porque hiciste clic en una tarjeta negra.",
  "out-of-time-loss": "¡Se te acabó el tiempo!",
  won: "¡Ganaste!",
  "join-red": "Únete al rojo",
  "join-blue": "Únete al azul",
  "join-side": "Únete al equipo",
  spectate: "Observar",
  "game-started": "ha comenzado",
  "page-title": "Codegame - Jugar en línea",
  "page-description":
    "Juega a Codegame (Código Secreto) en línea, un juego de palabras multijugador disponible en el teléfono y en el escritorio. En ese juego de adivinanzas, los equipos compiten para encontrar cartas relacionadas con la palabra clave dada.",
  "in-the-room": "En el juego",
  rules: "Reglas",
  // todo rules...
  red: "Rojo",
  blue: "Azul",
  duetA: "Equipo A",
  duetB: "Equipo B",
  spectator: "Observando",
  "just-joined": "se unió al juego!",
  "game-created": "El juego fue creado.",
  "no-players-yet": "¡Aún no hay jugadores en este equipo!",
  "player-name-placeholder": "Introduzca tu nombre del jugador",
  cards: "cartas",
  buymeacoffee: "Apoya el juego, cómprame un café",
  "positive-reaction-1": "Venga!",
  "positive-reaction-2": "¡Bien hecho!",
  "positive-reaction-3": "Jugada fuerte",
  "positive-reaction-4": "¡Un punto!",
  "positive-reaction-5": "Yay!",
  "positive-reaction-6": "😎",
  "neutral-reaction-1": "Es una falla.",
  "neutral-reaction-2": "Bastante cerca.",
  "neutral-reaction-3": "Lo tendrás la próxima vez.",
  "neutral-reaction-4": "Era un civil.",
  "neutral-reaction-5": "¡Casi!",
  "neutral-reaction-6": "Qué lástima",
  "black-reaction-1": "¡Acabas de perder el juego!",
  "black-reaction-2": "¡El otro equipo gana!",
  "black-reaction-3": "Tu equipo pierde ☠️",
  "black-reaction-4": "Oh no, hiciste clic en un asesino ☠️",
  "negative-reaction-1": "Whoops!",
  "negative-reaction-2": "¡Oh no!",
  "negative-reaction-3": "El otro equipo le agradece.",
  "negative-reaction-4": "No te preocupes, hiciste lo mejor que pudiste 💛",
  "negative-reaction-5": "🤦‍♂️",
  "rules-classic-teams":
    "Las tarjetas de 25 palabras se colocan al azar en una cuadrícula. Un número de estas palabras representan <1>rojo</1> agentes, un número representa <3>azul</3> agentes, uno representa un <5>assassin</5>, y los otros representan <7> espectadores inocentes</span>. Los espías de los equipos conocen los colores de cada palabra, y se turnan para insinuar a su equipo para que encuentren las palabras de su color.",
  "rules-classic-hints":
    "Cada pista sólo puede consistir en una sola palabra y un número de tarjetas con las que se relaciona. El espía da una pista relacionada con tantas palabras como sea posible en las tarjetas de sus propios agentes, pero no con ninguna otra - pueden llevar accidentalmente a su equipo a elegir una tarjeta que represente a un transeúnte inocente, a un agente contrario o al asesino.",
  "rules-hint-restrictions":
    "La palabra de la pista puede ser elegida libremente, siempre y cuando no sea (y no contenga) ninguna de las palabras en las tarjetas de nombres en código que todavía se muestran en ese momento. Las pistas fonéticas están típicamente prohibidas.",
  "rules-turns":
    "Las cartas se revelan a medida que se adivinan. Los agentes de campo deben hacer al menos una suposición por turno, arriesgándose a una suposición errónea y sus consecuencias. También pueden terminar su turno voluntariamente en cualquier momento a partir de entonces. Pueden adivinar hasta el número dado por el espía, más uno (un bono para encontrar una palabra previamente insinuada)",
  "rules-classic-game-end":
    "El juego termina cuando todos los agentes de un equipo son identificados (🏅), o cuando un equipo ha identificado el <1>assassin</1> (☠️).",
  "rules-duet-objective":
    "Dos jugadores cooperan para encontrar 15 palabras en el tablero",
  "rules-duet-grid":
    "Las tarjetas de 25 palabras están dispuestas al azar en una cuadrícula. Un número de estas palabras representan <1>verde</1> agentes, un número representa <3>assassins</3>, y los otros representan <5> espectadores inocentes</5>. Cada jugador conoce 9 <7>verdes</7> palabras, algunas de las cuales se superponen con el otro lado.",
  "rules-duet-hints":
    "Los jugadores dan alternativamente pistas para que el otro jugador encuentre sus tarjetas verdes. Cada pista sólo puede consistir en una sola palabra y un número de cartas con las que se relaciona. El espía da una pista relacionada con el mayor número posible de palabras en las cartas de sus propios agentes, pero no con ninguna otra - pueden llevar accidentalmente al otro jugador a elegir una carta que represente a un transeúnte inocente, o a un asesino",
  "rules-duet-game-end":
    "El juego termina cuando los 15 agentes verdes son identificados (🏅), o cuando un jugador ha identificado un <1>assassin</1> (☠️). El juego está cronometrado, lo que significa que los jugadores tienen un total de 9 turnos para encontrar todas las palabras. Haciendo clic en un <3>novato espectador</span> consume un turno extra.",
  "long-story-short": "En pocas palabras",
  "privacy-tldr": `
    <p>Guardamos juegos y chats en nuestra base de datos por algún tiempo, pero pueden ser borrados en cualquier momento. Esta es la única información que almacenamos.
    <p>Usamos cookies para poder ver los análisis sobre el uso del sitio (demografía, duración de las sesiones, tipos de juegos jugados). Esos análisis no contienen información personal identificable.
    <p>Nuestro proveedor de análisis es Google Analytics.</p>
  `,
};
